import { ErrorAlert } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export const ConversationError = () => {
  const intl = useProcurifyIntl()

  return <ErrorAlert>{intl.formatMessage(messages.genericError)}</ErrorAlert>
}
